import { backendApiService } from './backendApiService';

export interface PAAQuestion {
  id: number;
  url_id: string;
  keyword: string;
  check_date: string;
  question: string;
  answer?: string;
}

export interface PAAQuestionsResponse {
  questions: PAAQuestion[];
  pagination: {
    total: number;
    limit: number;
    offset: number;
  };
}

export interface PAAQueryParams {
  website_id?: string;
  url_id?: string;
  keyword_id?: string;
  country?: string;
  search?: string;
  limit?: number;
  offset?: number;
}

class PAAService {
  async getQuestions(params: PAAQueryParams): Promise<PAAQuestionsResponse> {
    try {
      const queryParams = new URLSearchParams();
      
      // Add parameters if they exist
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          queryParams.append(key, value.toString());
        }
      });

      const response = await (backendApiService as any).axiosInstance.get(`/api/paa/questions?${queryParams.toString()}`);
      
      if (response.data && !response.data.success) {
        throw new Error(response.data.error || 'Failed to fetch PAA questions');
      }

      return response.data.data as PAAQuestionsResponse;
    } catch (error) {
      console.error('Error fetching PAA questions:', error);
      throw error;
    }
  }


  async getSurpriseQuestion(website_id?: string): Promise<PAAQuestion | null> {
    try {
      const params = new URLSearchParams();
      if (website_id) params.append('website_id', website_id);

      const response = await (backendApiService as any).axiosInstance.get(`/api/paa/questions/surprise?${params.toString()}`);
      
      if (response.data && !response.data.success) {
        throw new Error(response.data.error || 'Failed to fetch surprise question');
      }

      return response.data.data as PAAQuestion | null;
    } catch (error) {
      console.error('Error fetching surprise question:', error);
      throw error;
    }
  }

}

export const paaService = new PAAService();